import React from 'react'
import { FormikProps } from 'formik'
import { PackType, IPackInput } from '../../types/pack'
import { ICapabilitiesSummary } from '../../types/capabilitiesSummary'
import { createDataChart } from '../../actions/datachart'
import { getAllowedCapability } from '../../services/capabilitiesSummary'
import { DetailsTemplate, Space } from '../../layouts'
import { CreateDataChartForm } from '../../forms'
import {
  FileUploadZone,
  Button,
  H2,
  PreviewPicture,
  DisabledUploadHint,
} from '../../components'

export interface IPackUploadTab {
  pack: PackType
  capabilitiesSummary?: ICapabilitiesSummary
  formikProps: FormikProps<IPackInput>
}

export const PackUploadTab = ({
  pack: { id: packId, group: groupId, previewImages, publishing },
  capabilitiesSummary,
  formikProps,
}: IPackUploadTab) => {
  const {
    showFileZone,
    showDataChartForm,
    showDataFile,
    showPasteImageFieldForPack,
  } = getAllowedCapability(capabilitiesSummary)
  const uploadDisabled = publishing?.publishing || formikProps.dirty
  return (
    <DetailsTemplate
      aside={
        <>
          <H2 mb={4}>Upload files</H2>
          <DisabledUploadHint packFormDirty={formikProps.dirty} />
          {showFileZone && (
            <Space mb={2}>
              <FileUploadZone
                id="file-input"
                disabled={uploadDisabled}
                groupId={groupId}
                allowPastingImages={showPasteImageFieldForPack}
              />
            </Space>
          )}
          {showDataChartForm && (
            <CreateDataChartForm
              onSubmitAction={createDataChart}
              disabled={uploadDisabled}
            />
          )}
          {showDataFile && (
            <Space mt={6} mb={2}>
              <Button
                fullWidth
                id="add-datafile-button"
                color="primary"
                variant="contained"
                to={`/group/${groupId}/pack/${packId}?edition=add-datafile&tab=upload`}
                disabled={uploadDisabled}
              >
                Add a data file
              </Button>
            </Space>
          )}
        </>
      }
      contentProps={{ id: 'pack-upload-tab-main' }}
      asideProps={{ id: 'pack-upload-tab-aside' }}
    >
      <H2 mb={4}>Preview image</H2>
      <PreviewPicture
        width="500px"
        height="calc(100% - 50px)"
        size="500px"
        src={previewImages && previewImages.previewURI}
      />
    </DetailsTemplate>
  )
}
